import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  changeProfilePicture(
    credentials: Boundaries["changeProfilePicture"]["request"],
  ): void;
}

function useChangeProfilePicture(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isChangeProfilePictureRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isChangeProfilePictureRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isChangeProfilePictureRequestFailure,
    ),
    changeProfilePicture: core.changeProfilePicture,
  };
}

export { useChangeProfilePicture };
